/**
 * @generated SignedSource<<fbc52d528a44d4772d66650374a98c3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigurationStorageCanEditFragment$data = {
  readonly parentProject: {
    readonly id: Branded<string, 'ProjectId'> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ConfigurationStorageCanEditFragment";
};
export type ConfigurationStorageCanEditFragment$key = {
  readonly " $data"?: ConfigurationStorageCanEditFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurationStorageCanEditFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigurationStorageCanEditFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectRest",
      "kind": "LinkedField",
      "name": "parentProject",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PipelineRest",
  "abstractKey": null
};

(node as any).hash = "d17f41df4d322c9f9660756adda23003";

export default node;
